import React, {useState, useEffect, useRef} from 'react';
import {Grid, TextField, Link, InputAdornment, Tooltip} from '@material-ui/core';
import {Types} from "../index";
import API from "@beardeddevops/react.api"
import {LineChart} from "react-chartkick";
import 'chart.js'
import moment from "moment-timezone";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Modal, ModalBody} from "reactstrap";
import Framework from "@beardeddevops/react.framework";
import FDCountDisplay from "../Parts/FDCountDisplay";

const ManagerCharts = ({dispatchView = false, triggerReload = null}) => {

	const [filterDate, setFilterDate] = useState(moment().format('YYYY-MM-DD'))
	const [showDate, setShowDate] = useState(false)
	const [phoneLogsData, setPhoneLogsData] = useState(null)
	const [hiringNotesData, setHiringNotesData] = useState(null)
	const [helpdeskNotesData, setHelpdeskNotesData] = useState(null)
	const [pendingCountData, setPendingCountData] = useState(null)
	const [dispatchCountData, setDispatchCountData] = useState(null)
	const [pendingCount, setPendingCount] = useState(null);
	const [dispatchCount, setDispatchCount] = useState(null);
	const intervalRef = useRef(null);
	const fdintervalRef = useRef(null);

	const startInterval = () => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current)
		}
		if (fdintervalRef.current) {
			clearInterval(fdintervalRef.current)
		}

		intervalRef.current = setInterval(async () => {
			if (triggerReload) {
				await triggerReload();
			}
			fetchData().then((chatData) => formatData(chatData))
		}, 15 * 60 * 1000)
		fdintervalRef.current = setInterval(() => {
			fetchFDData()
		}, 30 * 1000)
	}

	async function handleDateChange(name, date) {
		setFilterDate(moment(date).format('YYYY-MM-DD'));
		setShowDate(false)
	}

	function fetchFDData() {
		const pending_count = localStorage.getItem('pending_count');
		const dispatch_count = localStorage.getItem('dispatch_count');

		if ((pending_count || dispatch_count) && (pending_count !== pendingCount || dispatch_count !== dispatchCount)) {
			setDispatchCount(dispatch_count);
			setPendingCount(pending_count);
		}
	}

	useEffect(() => {
		fetchData().then((chartData) => formatData(chartData))
		fetchFDData();

		startInterval();

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current)
			}
			if (fdintervalRef.current) {
				clearInterval(fdintervalRef.current)
			}
		}
	}, []);

	useEffect(() => {
		fetchData().then((chartData) => formatData(chartData))
	}, [filterDate]);

	async function fetchData() {
		startInterval()
		let model = new API.BuildClass(Types.Managers._name, API.RequestType.READ);
		model.filter = {
			'filterDate': filterDate,
			'dispatchView': dispatchView
		}
		return await model.submit(null, 'GET_CHARTS');
	}

	function parseData(array, useOtherFormula = false, timeAdjust = null) {

		if (useOtherFormula) {
			// Group into 15-minute intervals
			const intervalGroups = {};

			array.forEach(item => {
				const time = moment(item.created);
				if (timeAdjust) {
					time.subtract(timeAdjust, 'hours')
				}
				const minutes = Math.floor(time.minutes() / 15) * 15;
				const bucket = time.clone().minutes(minutes).seconds(0).format("HH:mm");

				if (!intervalGroups[bucket]) {
					intervalGroups[bucket] = { sum: 0, count: 0 };
				}

				intervalGroups[bucket].sum += parseInt(item.total, 10);
				intervalGroups[bucket].count += 1;
			});


			const chartData = Object.entries(intervalGroups).map(([time, { sum, count }]) => {
				const avg = Math.round(sum / count);
				return [time, avg];
			});


			return chartData.sort((a, b) => moment(a[0], "HH:mm").diff(moment(b[0], "HH:mm")));
		}
		// Trim zeros from the start and end
		const trimmedArray = trimZeros(array);

		return trimmedArray.reduce((acc, item) => {
			const formattedHour = moment(item.hour, "H").format("hA"); // Format hour using moment
			acc[formattedHour] = parseFloat(item.total); // Ensure numeric values for totals
			return acc;
		}, {});
	}

	function trimZeros(array) {
		// Find the first index that isn't zero
		const startIndex = array.findIndex(item => parseFloat(item.total) !== 0);
		// Find the last index that isn't zero
		const endIndex = array.length - 1 - array.slice().reverse().findIndex(item => parseFloat(item.total) !== 0);

		// Slice the array to keep only the relevant portion
		return array.slice(startIndex, endIndex + 1);
	}


	function formatData(chartData) {
		if (!dispatchView) {
			setHiringNotesData(parseData(chartData.hiring_notes))
			setHelpdeskNotesData(parseData(chartData.helpdesk_notes))
			setPhoneLogsData(parseData(chartData.phone_logs))
		}
		setDispatchCountData(parseData(chartData.fd_dispatch_counts_data, true, chartData.diag))
		setPendingCountData(parseData(chartData.fd_pending_counts_data, true, chartData.diag))

	}

	return (
		<div style={styles.wrapper}>
			<Modal
				isOpen={showDate}
				toggle={() => setShowDate(!showDate)}
				size={"sm"}
				backdrop={true}
				style={{display: "none"}}
			>
				<ModalBody>
					<Framework.Elements.Date
						label={"Custom Date"}
						value={filterDate}
						update={handleDateChange}
						open={showDate}
						clearable={false}
						cancelLabel={''}
					/>
				</ModalBody>
			</Modal>
			{/* Toolbar */}
			<div className={"row rbc-toolbar"}>
				<div>
					<IconButton onClick={async () => {
						setFilterDate(moment(filterDate).subtract(1, 'day').format('YYYY-MM-DD'))
					}}><LeftArrowIcon/></IconButton>
					<button className="rbc-today" type="button" onClick={async () => {
						setFilterDate(moment(Date.now()).format('YYYY-MM-DD'))
					}}>Today
					</button>
					<IconButton onClick={async () => {
						setFilterDate(moment(filterDate).add(1, 'day').format('YYYY-MM-DD'))
					}}><RightArrowIcon/></IconButton>
				</div>

				<div style={{flexGrow: 1, display: 'flex', flexDirection: 'row', justifyContent: "space-around"}}>
					{!dispatchView && <FDCountDisplay count={dispatchCount} type={'dispatch'} showChart={false}/>}

					<div className={"rbc-toolbar-label"} style={{flexGrow: 0}}>
						<label onClick={() => {
							setShowDate(true)
						}}>
							{moment(filterDate).format('dddd MMM D')}
						</label>
					</div>

					{!dispatchView && <FDCountDisplay count={pendingCount} type={'pending'} showChart={false}/>}
				</div>

				<button className="rbc-today" type="button" onClick={async () => {
					fetchData().then((chatData) => formatData(chatData))
					if (triggerReload) {
						await triggerReload();
					}
				}}>Refresh
				</button>
			</div>


			{!dispatchView && <div style={styles.chartContainer}>
				<div style={styles.chart}>
					<h3 style={styles.chartTitle}>Phone Logs Created</h3>
					<LineChart data={phoneLogsData}/>
				</div>
				<div style={styles.chart}>
					<h3 style={styles.chartTitle}>Helpdesk Note Chars</h3>
					<LineChart data={helpdeskNotesData}/>
				</div>
				<div style={styles.chart}>
					<h3 style={styles.chartTitle}>Hiring Note Chars</h3>
					<LineChart data={hiringNotesData}/>
				</div>
			</div>}

			<div style={styles.chartContainer}>
				<div style={styles.chart}>
					<h3 style={styles.chartTitle}>Dispatch Tickets</h3>
					<LineChart data={dispatchCountData}/>
				</div>
				<div style={styles.chart}>
					<h3 style={styles.chartTitle}>Pending Tickets</h3>
					<LineChart data={pendingCountData}/>
				</div>
			</div>

		</div>
	);

};

const styles = {
	wrapper: {
		display: "flex",
		flexDirection: "column",
		gap: "8px", // Space between toolbar and charts
		//padding: "16px", // Outer padding
	},
	chartTitle: {
		textAlign: "center",
		marginBottom: "8px",
		fontSize: "18px",
		fontWeight: "bold",
	},
	labelText: {
		fontSize: "1.2em",
	},
	chartContainer: {
		display: "flex",
		flexWrap: "wrap",
		gap: "16px",
		justifyContent: "space-between",
	},
	chart: {
		flex: "1 1 30%",
		minWidth: "300px",
		maxWidth: "100%",
	},
	'rbc-toolbar': {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '10px',
	},
	'toolbar-section': {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
	},
	'toolbar-center': {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		flexGrow: 1,
		minWidth: 200,
	}
};

export default ManagerCharts;